import {IS_CLIENT_SIDE} from './constants';

export function isWindowScrollDisabled() {
  return IS_CLIENT_SIDE && window.document.body.style.position === 'fixed';
}
